import instance from "../../axios/axios-user";
import { PostVideoProps } from "../../redux/slices/postVideo/postVideo";
import { API_PATHS } from "../api_paths";

const createVideoDraftForAPost = ({
  post_id,
}: PostVideoProps.createVideoDraftForAPostPayload) => {
  return instance(API_PATHS.posts.post + post_id + "/video-draft", {
    method: "POST",
  });
};

const uploadVideoToAPost = ({
  post_id,
  video,
  content_id,
}: PostVideoProps.uploadVideoToAPostPayload) => {
  const formData = new FormData();
  formData.append("video", video);
  formData.append("content_id", content_id);
  return instance(API_PATHS.posts.post + post_id + "/video", {
    method: "POST",
    data: formData,
  });
};

const deleteVideoFromAPost = ({
  post_id,
  video_id,
}: PostVideoProps.deleteVideoFromAPostPayload) => {
  return instance(API_PATHS.posts.post + post_id + "/video/" + video_id, {
    method: "DELETE",
  });
};

const getPostVideo = (post_id: string) =>
  instance(API_PATHS.postVideo.getPostVideo + post_id);

export const POSTVIDEO = {
  createVideoDraftForAPost,
  uploadVideoToAPost,
  deleteVideoFromAPost,
  getPostVideo,
};
